<script setup lang="ts">
import Customer from "@/customer/interfaces/Customer";
import TimelineLoading from "@/appointment/components/consumer-appointment-timeline/TimelineLoading.vue";
import Timeline from "@/appointment/components/consumer-appointment-timeline/Timeline.vue";
import useCustomerAppointments from "@/appointment/composables/useCustomerAppointments";

/**
 * The patient's active appointments on a timeline, without any header: the
 * home of the file frames it with its actions, the « Rendez-vous » tab sets
 * it above the calendar.
 */
const props = defineProps<{
    customer: Customer;
}>();

const emit = defineEmits<{
    /** An appointment was cancelled, moved or deleted from the timeline. */
    (event: 'changed'): void
}>();

const {data: appointments, isLoading, mutate} = useCustomerAppointments(props.customer.id);

const handleReload = () => {
    mutate();
    emit('changed');
};
</script>

<template>
  <div class="relative w-full">
    <TimelineLoading v-if="isLoading" />
    <p
      v-else-if="!appointments || appointments.length === 0"
      class="text-sm text-gray-500"
    >
      Aucun rendez-vous planifié. Prenez un rendez-vous pour ce patient : vaccination,
      entretien, bilan de prévention.
    </p>
    <Timeline v-else :appointments="appointments" @reload="handleReload" />
  </div>
</template>
